module.exports = __webpack_public_path__ + "img/dollar-sign.80625eff.svg";